import { graphql } from '@graphql/__generated'

export const SYNC_EVENT_ATTENDEES_WITH_ZAPIER = graphql(`
  mutation SyncEventAttendeesWithZapier($eventId: String!) {
    syncEventAttendeesWithZapier(eventId: $eventId) {
      success
      attendeesSynced
      attendanceUpdatesSynced
      error
    }
  }
`)
